
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wiki/roles",
      function () {
        return require("private-next-pages/wiki/roles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wiki/roles"])
      });
    }
  